import type { JSX } from 'react'

import { pinkVariables, variables } from "/app/libraries/arcana/src/theme/index.ts"
import { THEME_WRAPPER_CLASSNAME } from "/app/libraries/arcana/src/utils/index.ts"

import { useUnit } from 'effector-react'
import { useLayoutEffect } from 'react'
import { appearanceFeature } from '~/features/appearance'

import './ThemeProvider.css'

interface Props {
  children: React.ReactNode
}

const AVAILABLE_THEMES: Record<AppTheme, string> = {
  pink: pinkVariables,
}
const getEraTheme = () => {
  const theme = window.ERA_CONFIG?.theme
  return theme ? AVAILABLE_THEMES[theme] : ''
}
const ERA_THEME = getEraTheme()
const DOCUMENT_SCROLL_ROOT_CLASS = 'tria-document-scroll-root'
const BODY_SCROLL_ROOT_CLASS = 'tria-body-scroll-root'

/**
 * Not actually a _context_ provider, just wrapper for styling
 */

ThemeProvider.displayName = 'ThemeProvider'
export function ThemeProvider({ children }: Props): JSX.Element {
  useLayoutEffect(() => {
    document.documentElement.classList.add(DOCUMENT_SCROLL_ROOT_CLASS)
    document.body.classList.add(variables, BODY_SCROLL_ROOT_CLASS)
    if (ERA_THEME) {
      document.body.classList.add(ERA_THEME)
    }

    return () => {
      document.documentElement.classList.remove(DOCUMENT_SCROLL_ROOT_CLASS)
      document.body.classList.remove(variables, BODY_SCROLL_ROOT_CLASS)
      if (ERA_THEME) {
        document.body.classList.remove(ERA_THEME)
      }
    }
  }, [])

  const appTheme = useUnit(appearanceFeature.$appTheme)

  return (
    <div
      data-testid='theme-provider'
      className={`${variables} ${ERA_THEME} layout ${THEME_WRAPPER_CLASSNAME}`}
      style={appTheme ?? undefined}
    >
      {children}
    </div>
  )
}
